import { portalConfig } from "../reducers/portalConfigReducer";
import store from "../store";

export function setPortalConfig(portalFeatureLayoutConfig: portalConfig | null){
    store.dispatch({
        type: "setPortalConfig",
        payload: portalFeatureLayoutConfig
    })
}